import { render, staticRenderFns } from "./LastCompare.vue?vue&type=template&id=c6752cec&scoped=true&"
import script from "./LastCompare.vue?vue&type=script&lang=js&"
export * from "./LastCompare.vue?vue&type=script&lang=js&"
import style0 from "./LastCompare.vue?vue&type=style&index=0&id=c6752cec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6752cec",
  null
  
)

export default component.exports